<template v-if="ready && tacticalsExits">
    <template v-if="tacticalHostWidgets.length > 0">
    <b-row class="pb-2">
        <b-col class="text-center">
            <h5> {{ $t('Tactical overviews for hosts') }}</h5>
        </b-col>
    </b-row>
        <b-card-group deck>
            <template v-for="hostwidget in tacticalHostWidgets" v-bind:key="hostwidget.id" class="d-inline mb-2">
            <tactical-host-widget :widget_id="hostwidget.id" :title="hostwidget.title" :theme="theme"/>
            </template>
        </b-card-group>
    </template>
    <template v-if="tacticalServiceWidgets.length > 0">
        -<b-row class="pb-2">
            <b-col class="text-center">
                <h5> {{ $t('Tactical overviews for services') }}</h5>
            </b-col>
        </b-row>
            <b-card-group deck>
                <template  v-for="servicewidget in tacticalServiceWidgets" v-bind:key="servicewidget.id" class="inline mb-2">
                    <tactical-service-widget :widget_id="servicewidget.id" :title="servicewidget.title" :theme="theme"/>
                </template>
            </b-card-group>
    </template>
</template>
<script>
import TacticalHostWidget from "./TacticalHostWidget.vue";
import TacticalServiceWidget from "./TacticalServiceWidget.vue";
import { BRow } from 'bootstrap-vue-next';
export default {
    name: "Widgets",
    components: {
        BRow,
        TacticalHostWidget, TacticalServiceWidget
    },
    data() {
        return {
            ready: false,
            tacticalHostWidgets: [],
            tacticalServiceWidgets: [],
            theme: 'light'
        }
    },
    async mounted() {
        await this.getWidgets();
        this.ready = true;

    },
    methods: {
        async getWidgets(){
            axios.post('/dashboards/widgets.json').then(result => {
                this.tacticalHostWidgets = result.data.tacticalHoststatusOverviews || [];
                this.tacticalServiceWidgets = result.data.tacticalServicestatusOverviews || [];
            }).catch(error => {
                console.log(error)
            });
        },
    },
    computed: {
        tacticalsExits() {
            return this.tacticalHostWidgets.length > 0 || this.tacticalServiceWidgets.length > 0;
        }
    }
}
</script>



<style scoped>

</style>
